export default {
  MODULES: `Modules`,
  ACTIVE_MODULES: `Activate modules`,
  AVAILABLE_MODULES: `Available modules`,
  AN_OTHER_INTEGRATION_PREVENTS_USE: `An other integration prevents the use of this one.`,
  WORKDAY: {
    TITLE: `Workday`,
    SUMMARY: `This integration allows to sync the schedule, the projects, the clients, the regions and the users with Workday.`
  },
  ROSTIMA: {
    TITLE: `Rostima`,
    SUMMARY: `This integration allows to sync the schedule, the attendance requests and the users with Rostima.`
  },
  CERIDIAN: {
    TITLE: `Ceridian`,
    SUMMARY: `This integration allows to sync the schedule, the punch cards and users with Ceridian.`,
    SETUP_FTP_INFO: `Please contact us to setup the SFTP for this integration.`
  },
  FOLKSRH: {
    TITLE: `FolksRH`,
    SUMMARY: `This integration allows to sync the users from FolksRH.`
  },
  GENERAL: { TITLE: `General`, SUMMARY: `` },
  SCHEDULE: { TITLE: `Schedule`, SUMMARY: `` },
  ATTENDANCE: { TITLE: `Attendance`, SUMMARY: `` },
  TIMEOFF: { TITLE: `Time off`, SUMMARY: `` },
  AVAILABILITIES: { TITLE: `Availabilities`, SUMMARY: `` },
  TIMEATTENDANCE: { TITLE: `Payroll`, SUMMARY: `` },
  EMPLOYEE: { TITLE: `Employees`, SUMMARY: `` },
  CALLSYSTEM: { TITLE: `Call system`, SUMMARY: `` },
  DEPLOYMENT: { TITLE: `Deployment`, SUMMARY: `` },
  DAILYQUESTIONNAIRE: { TITLE: `Daily questionnaire`, SUMMARY: `` },
  PUNCHTERMINALQUESTIONNAIRE: { TITLE: `Punch terminal questionnaire`, SUMMARY: `` },
  TRANSITION: { TITLE: `Transition`, SUMMARY: `` },
  form: {
    PROJECTISREQUIRED: {
      LABEL: `The project is required`,
      DESCRIPTION: `The project will be required when creating a new shift, schedule template, or punch card.`
    },
    TEAMISREQUIRED: {
      LABEL: `The team is required`,
      DESCRIPTION: `The team will be required when creating a new shift, schedule template, or punch card.`
    },
    ENABLESCHEDULENOTES: {
      LABEL: `Enable schedule notes`,
      DESCRIPTION: `All managers with schedule edit access will be able to create schedule notes.`
    },
    ENABLEORGANIZEBYUSERSCHEDULE: {
      LABEL: `Enable organizing by user in schedule`,
      DESCRIPTION: `Activates an experimental feature for organizing the schedule by user.`
    },
    ENABLEPUNCHGEOLOCATION: {
      LABEL: `Add geolocation coordinates to punch cards`,
      DESCRIPTION: `It will require mobile app users to enable location services in device settings.`
    },
    REQUIREEMPLOYEELOCATION: {
      LABEL: `Require employee location`,
      DESCRIPTION: `Requires employee have location services enabled to punch in or out.`
    },
    ENABLEAUTOMATICWAGEPREMIUMSBYATTRIBUTE: {
      LABEL: `Enable automatic wage premiums by attributes`,
      DESCRIPTION: `Allows configuring wage premiums to be automatically assigned based on user wage premiums.`
    },
    ENABLEAUTOMATICWAGEPREMIUMSBYRANGE: {
      LABEL: `Enable automatic wage premiums by range`,
      DESCRIPTION: `Allows configuring wage premiums to be automatically assigned based on when the punch card is.`
    },
    ENABLEEMPLOYEECONTAINERSCHEDULER: {
      LABEL: `Enable grouping employees by line in scheduler`,
      DESCRIPTION: `Forces employees to be on the same line if they are at the same position in the schedule.`
    },
    ENABLESANITYCHECKCONTACTLISTS: {
      LABEL: `Enable sanity check in contact lists`,
      DESCRIPTION: `Adds a check to make sure employee is still eligible for a shift before accepting.`
    },
    IGNOREREPORTSTOFORPROJECTS: {
      LABEL: `Ignore reports to for projects`,
      DESCRIPTION: `All managers will have access to all projects regardless of whether they are the project owner.`
    },
    PAYPERIOD: {
      TITLE: `Pay period`,
      BASEDATE: {
        LABEL: `Base date`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Beginning reference date for the pay period.`
      },
      PERIODDURATION: {
        LABEL: `Duration`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Pay period in weeks.`
      }
    },
    FTPOPTIONS: {
      LABEL: `Ftp information from where to get/drop the files of the connection.`,
      DESCRIPTION: ``
    },
    ISTESTCOMPANY: {
      LABEL: `This platform is a test environement`,
      DESCRIPTION: `Some features will be unavailable when this setting is active.`
    },
    FORCEEMPLOYEEPORTAL: {
      LABEL: `Force employees to new portal`,
      DESCRIPTION: `If a user with employee type is logging in on the old platform, they will be redirected automatically to the new platform.`
    },
    FORCENEWPORTAL: {
      LABEL: `Force EVERYONE to new portal`,
      DESCRIPTION: `If any user is logging in on the old platform, they will be redirected automatically to the new platform.`
    },
    DISABLEOLDPORTAL: {
      LABEL: `Prevent EVERYONE from going back to old portal`,
      DESCRIPTION: `Will remove the link in the dropdown menu at the top right allowing users to switch between portals.`
    },
    ACTIVATEWORKDAYINTEGRATION: {
      LABEL: `Activate Workday integration`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYUSERS: {
      LABEL: `Activate the transfer of the users`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYSCHEDULE: {
      LABEL: `Activate the transfer of the schedule`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYTAGS: {
      LABEL: `Activate the transfer of the tags`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYPOSITIONS: {
      LABEL: `Activate the transfer of the positions`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYPROJECTS: {
      LABEL: `Activate the transfer of the projects`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYATTENDANCES: {
      LABEL: `Activate the transfer of the absences`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYAVAILABILITIES: {
      LABEL: `Activate the transfer of the availabilities`,
      DESCRIPTION: ``
    },
    ACTIVATEWORKDAYTIMEOFF: {
      LABEL: `Activate the transfer of the time off`,
      DESCRIPTION: ``
    },
    WORKDAYREIMBURSEMENTSURL: {
      LABEL: `Reimbursements url`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    WORKDAYPASSWORD: {
      LABEL: `Password`,
      PLACEHOLDER: `Enter the password`,
      DESCRIPTION: `Password of the Workday integration account, this account should have access to all the resources required by the integration.`
    },
    WORKDAYUSERNAME: {
      LABEL: `Username`,
      PLACEHOLDER: `Enter the username`,
      DESCRIPTION: `Username of the Workday integration account, this account should have access to all the resources required by the integration.`
    },
    WORKDAYUSERSURL: {
      LABEL: `Users WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYERROREMAIL: {
      LABEL: `Error report email`,
      PLACEHOLDER: `Enter one or multiple email addresses`,
      DESCRIPTION: `Email that error reports will be sent to, separate multiple email addresses using commas`
    },
    WORKDAYUSERONBOARDINGURL: {
      LABEL: `User onboarding report URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYSCHEDULEURL: {
      LABEL: `Schedule WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYINTEGRATIONSURL: {
      LABEL: `Integrations WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYTIMEBLOCKMAPURL: {
      LABEL: `Timeblock map WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYCLIENTSURL: {
      LABEL: `Clients WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYREGIONSURL: {
      LABEL: `Regions WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYLOCATIONSURL: {
      LABEL: `Locations WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYPOSITIONSURL: {
      LABEL: `Positions WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYPROJECTSURL: {
      LABEL: `Projects WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYATTENDANCESURL: {
      LABEL: `Absences WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    WORKDAYTIMEOFFURL: {
      LABEL: `Time off WSDL URL`,
      PLACEHOLDER: `Enter the WSDL link`,
      DESCRIPTION: ``
    },
    ACTIVATECERIDIANINTEGRATION: {
      LABEL: `Activate Ceridian integration`,
      DESCRIPTION: ``
    },
    ACTIVATECERIDIANPUNCH: {
      LABEL: `Activate the adjustment of the schedule from the punch`,
      DESCRIPTION: ``
    },
    ACTIVATECERIDIANSCHEDULE: {
      LABEL: `Activate the transfer of the schedule`,
      DESCRIPTION: ``
    },
    ACTIVATECERIDIANUSERS: {
      LABEL: `Activate the transfer of the users`,
      DESCRIPTION: ``
    },
    ACTIVATEROSTIMAINTEGRATION: {
      LABEL: `Activate Rostima integration`,
      DESCRIPTION: ``
    },
    ROSTIMAUSERNAME: {
      LABEL: `Username`,
      PLACEHOLDER: `Enter the username`,
      DESCRIPTION: `Username of the Rostima integration account, this account should have access to all the resources required by the integration.`
    },
    ROSTIMAPASSWORD: {
      LABEL: `Password`,
      PLACEHOLDER: `Enter the password`,
      DESCRIPTION: `Password of the Rostima integration account, this account should have access to all the resources required by the integration.`
    },
    ROSTIMAURL: {
      LABEL: `Url`,
      PLACEHOLDER: `Enter the service url`,
      DESCRIPTION: `Url for the rostima service`
    },
    ACTIVATEROSTIMAATTENDANCES: {
      LABEL: `Activate the transfer of the absence into Rostima`,
      DESCRIPTION: ``
    },
    ACTIVATEROSTIMAUSERS: {
      LABEL: `Activate the transfer of the users into Merinio`,
      DESCRIPTION: ``
    },
    ACTIVATEROSTIMASCHEDULE: {
      LABEL: `Activate the transfer of the schedule into Merinio`,
      DESCRIPTION: ``
    },
    ACTIVATEROSTIMATIMEOFF: {
      LABEL: `Activate the transfer of the time off into Merinio`,
      DESCRIPTION: ``
    },
    ACTIVATEFOLKSRHINTEGRATION: {
      LABEL: `Activate FolksRH integration`,
      DESCRIPTION: ``
    },
    FOLKSRHCLIENTID: {
      LABEL: `Client ID`,
      DESCRIPTION: `Client ID for the FolksRH integration`,
      PLACEHOLDER: `Enter the client ID`
    },
    FOLKSRHCLIENTSECRET: {
      LABEL: `Client Secret`,
      DESCRIPTION: `Client Secret for the FolksRH integration`,
      PLACEHOLDER: `Enter the client secret`
    },
    FOLKSRHCLIENTUUID: {
      LABEL: `Client UUID`,
      DESCRIPTION: `Client unique identifier for the FolksRH integration`,
      PLACEHOLDER: `Enter the uuid`
    },
    FOLKSRHCLIENTURL: {
      LABEL: `Client url`,
      DESCRIPTION: `Url to use for the FolksRH integration`,
      PLACEHOLDER: `Enter the url`
    },
    INVALID_SCOPE: `Invalid Permissions Scope`,
    INVALID_CLIENT: `Invalid Client ID or Client Secret`,
    DISPLAYTAGCUSTOMFIELDS: {
      LABEL: `Display the tag's custom fields`,
      DESCRIPTION: `These fields are useful to set the earning code to add to the report when it is generated.`
    },
    ISLARGECOMPANY: {
      LABEL: `Large company`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Disables certain heavy calculations in order to speed up the platform on larger datasets.`
    },
    DISABLETWILIO: {
      LABEL: `Disable twilio`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Disables phone calls and sms, preventing company from accumulating twilio costs. Contact lists will be limited to push notifications`
    },
    DISABLEEMAILS: {
      LABEL: `Disable email notifications`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Disables all email notifications to avoid sending employees emails while a customer being deployed.`
    },
    GEOLOCALIZATION: {
      LABEL: `Geolocalisation`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows sorting of employees based on distance to shift.`
    },
    SPLITOVERNIGHTSHIFTS: {
      LABEL: `Split overnight shifts`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Overnight shifts will be split when calculating payroll and hours worked. Shifts worked overnight over two weeks will count partially in both weeks.`
    },
    STANDARDTIMEDATEDISPLAY: {
      LABEL: `Standard time`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If active, hours will be shown in standard time (AM/PM) rather than military time. `
    },
    STANDARDTIMEDATEDISPLAYWEEKLYREPORT: {
      LABEL: `Standard time in weekly report`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If active, hours in weekly report will be exported in standard time (AM/PM) rather than military time.`
    },
    ENABLEPROFILEPICTURE: {
      LABEL: `Profile pictures`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Activates profile pictures for users, they will be able to set them using a free Gravatar profile.`
    },
    ENABLEPREFERREDPRONOUNS: {
      LABEL: `Pronouns`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows selection of desired pronouns for users.`
    },
    ENABLELEGALNAME: {
      LABEL: `Legal name`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows selection of legal name.`
    },
    COMPANYNAMEEN: {
      LABEL: `Company name in english`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Name that will be used in written communication with employees.`
    },
    COMPANYNAMEFR: {
      LABEL: `Company name in french`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Name that will be used in written communication with employees.`
    },
    DEFAULTTIMEZONE: {
      LABEL: `Default time zone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Time zone to be used by default when creating resources such as shifts, attendance requests or time off.`
    },
    NUMBEROFALLOWEDPHONES: {
      LABEL: `Maximum number of phones`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Limits the quantity of phone numbers that a user can add to their profile. This limit can always be exceeded by using the manager portal.`
    },
    RESTRICTPHONENUMBERTYPES: {
      LABEL: `Allowed phone types`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Limits what types of phone numbers that users can add to their profile.`
    },
    SHOWPHONENUMBERHOMECALL: {
      LABEL: `Allow home numbers`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to add Home/Call numbers to their profile.`
    },
    SHOWPHONENUMBERMOBILECALL: {
      LABEL: `Allow mobile numbers`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to add Mobile/Call numbers to their profile.`
    },
    SHOWPHONENUMBERMOBILESMS: {
      LABEL: `Allow SMS numbers`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to add Mobile/Text numbers to their profile.`
    },
    SHOWPHONENUMBERDONOTUSE: {
      LABEL: `Allow unused numbers`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to add unused numbers to their profile.`
    },
    LIMITNOTIFICATIONTOWORKEMAIL: {
      LABEL: `Limit to work emails`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Limits notifications sent to manager to work type emails. Personal notifications will always be sent to all available emails.`
    },
    DEFAULTDELAYBETWEENCALLS: {
      LABEL: `Default delay between calls`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Number of minutes the system will wait before starting another concurrent call.`
    },
    COUNTREPLACEDSHIFTHOURS: {
      LABEL: `Count replaced hours in total`,
      PLACEHOLDER: ``,
      DESCRIPTION: `When active, shifts on which users have been replaced will still be counted in their total worked hours.`
    },
    SAYPOSITIONNAMESINCALLS: {
      LABEL: `Say position names during calls`,
      PLACEHOLDER: ``,
      DESCRIPTION: `When active, the name of the position a shift is on will be said during contact list calls.`
    },
    SENDEMAILCONFIRMATIONCOPYTO: {
      LABEL: `CC-to emails`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Email to cc when sending email notifications of accepted shifts, use semicolons ";" to separate entries.`
    },
    READSHIFTCOMMENT: {
      LABEL: `Read shift comment in shift notifications`,
      PLACEHOLDER: ``,
      DESCRIPTION: `When sending shift notifications over the phone, comments on shifts will also be read.`
    },
    SHIFTARRIVALTIMERANGE: {
      LABEL: `Ask for arrival time`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If the shift starts within the specified range, the user will be asked to provide an estimated arrival time.`
    },
    ENABLECONCURRENTCALLSRATIO: {
      LABEL: `Activate concurrent call ratio`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enables use of a ratio to calculate how many concurrent calls may be made based on remaining number of shifts in a contact list.`
    },
    CONCURRENTCALLSRATIO: {
      LABEL: `Concurrent call ratio`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Ratio to be used between number of waiting calls and number of shifts remaining in contact lists.`
    },
    ACTIVATEBACKUPCALLS: {
      LABEL: `Activate auto callback`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enables an auto callback, where user will be called back after a certain delay if they did not answer the first call in a contact list.`
    },
    BACKUPCALLSDELAY: {
      LABEL: `Delay before auto callback`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Delay that the system will wait for before initiating an auto callback.`
    },
    MAXACTIVECONTACTALLOWED: {
      LABEL: `Maximum number of active calls`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Defines the maximum number of active calls in a contact list that can be lowered individually in contact lists.`
    },
    MAXCONCURRENTCONTACTALLOWED: {
      LABEL: `Maximum number of concurrent calls`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Defines the maximum number of concurrent calls in a contact list that can be lowered individually in contact lists.`
    },
    ACTIVATEATTENDANCEPHONE: {
      LABEL: `Activate attendance requests over the phone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to create attendance requests using the phone system.`
    },
    ACTIVATEMESSAGEPHONE: {
      LABEL: `Activate shift offers over the phone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to listen to their shift offers using the phone system.`
    },
    ACTIVATESCHEDULEPHONE: {
      LABEL: `Activate schedule over the phone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to listen to their schedule using the phone system.`
    },
    ACTIVATEPUNCHPHONE: {
      LABEL: `Activate punching over the phone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to punch in and out using the phone system.`
    },
    ACTIVATEPHONECONFIRMATIONS: {
      LABEL: `Activate schedule notifications by phone`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enables schedule notifications to be sent by phone rather than by email.`
    },
    HOURSOFOPERATION: {
      LABEL: `Activate hours of operation`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Determines the period in which users can be contacted by contact lists or can accept shift offers. Users will still be able to create attendance requests or listen to their schedule outside of hours of operation.`
    },
    FORCECANCELLEDSHIFTS: {
      LABEL: `Prevent deleting shifts`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Adds steps to delete shifts rather than cancelling them. Cancelled shifts can always be restored, but deleted shifts are gone forever.`
    },
    ENABLERECCURENCE: {
      LABEL: `Enable recurring shifts`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Adds an interface to define recurring shifts in the schedule.`
    },
    HIDEUNASSIGNABSENCESTIMEOFFSCHEDULE: {
      LABEL: `Hide warning for absences & time off`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Hides a button that allows managers to quickly unassign all employees that are absent and on time off.`
    },
    EDITFINALIZEDSHIFTS: {
      LABEL: `Allow editing of finalized shifts`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to edit finalized shifts, otherwise it is only possible to edit unfinalized shifts.`
    },
    BREAKSAREREQUIRED: {
      LABEL: `Require breaks`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Require entering breaks when creating or editing a shift.`
    },
    SHOWONLYPUBLISHEDSHIFTSINMYSCHEDULE: {
      LABEL: `Show only published shifts in employee portal`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Shifts shown to users in the employee portal will not include unpublished shifts.`
    },
    AUTOAPPROVEUNPUNCHEDSHIFTS: {
      LABEL: `Auto-approve unpunched shifts`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Creating punch cards from the unpunched shifts modal will be automatically approved and will automatically be selected.`
    },
    DEFAULTSCHEDULETYPE: {
      LABEL: `Default Shift Type`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This shift's start and end times will appear as the default values in shift creation.`
    },
    DEFAULTBEGINNINGOFWEEKDAY: {
      LABEL: `Default beginning of week`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Set the day on which the week begins, as displayed in the weekly schedule view. Default is Sunday.`
    },
    ACTIVATEOVERVIEW: {
      LABEL: `Activate overview of the schedule`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    SORTEVENTSBYEMPLOYEENAME: {
      LABEL: `Sort shifts by employee name`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sort identical shifts (position and time) by the first or last name of the assigned employee.`
    },
    EVENTSORTFIELD: {
      LABEL: `Sort shifts by employee name`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sort identical shifts (position and time) by the first or last name of the assigned employee.`
    },
    MAXCAPACITYLOAD: {
      LABEL: `Max number of months for capacity report to load concurrently`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If you have a large number of users and/or shifts, it is not recommended to select '2 months'.`
    },
    DISPLAYPOSITIONSINMAINTEMPLATESVIEW: {
      LABEL: `Display position information in main template list view`,
      PLACEHOLDER: ``,
      DESCRIPTION: `A single day schedule template's shifts per position count is currently viewable via the details modal. This setting additionally enables the display of this information beneath each template entry in the main schedule template list view.`
    },
    TWILIONUMBER: {
      LABEL: `Phone number (twilio)`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TWILIOSID: {
      LABEL: `SID (twilio)`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TWILIOAUTHTOKEN: {
      LABEL: `Auth token (twilio)`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TWILIOURL: {
      LABEL: `URL (twilio)`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TWILIONAMEFR: {
      LABEL: `Phonetic company name in french`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Name that will be used in phone communication with employees`
    },
    TWILIONAMEEN: {
      LABEL: `Phonetic company name in english`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Name that will be used in phone communication with employees`
    },
    TWILIONUMBERPRETTY: {
      LABEL: `Pretty phone number (twilio)`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TWILIOMAINLANGUAGE: {
      LABEL: `Default language of the call system`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    BELONGSTOGROUP: {
      LABEL: `Belongs to group `,
      PLACEHOLDER: ``,
      DESCRIPTION: `A group that this company belongs to, this enables setting a single phone number for multiple companies`
    },
    BELONGSTOGROUPORDER: {
      LABEL: `Order in the group`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Companies in group with lower values will be said first in the phone call`
    },
    CLIENTSTATUS: {
      LABEL: `Client status`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PLANTYPE: {
      LABEL: `Plan type`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PERUSERPRICE: {
      LABEL: `Price per user`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PERCONTACTPRICE: {
      LABEL: `Price per contact`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    MAXUSER: {
      LABEL: `Max allowed user`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    BILLEDUSER: {
      LABEL: `Billable amount of users`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    MAXCONTACT: {
      LABEL: `Max allowed contact`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    BILLEDCONTACT: {
      LABEL: `Billable amount of contact `,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    AUTOMATICSCHEDULING: {
      LABEL: `Automatic scheduling 2`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting enables the automatic shift fulfillment in the main scheduler.`
    },
    ENABLECLIENTSENIORITY: {
      LABEL: `Seniority by client`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the seniority by client field visible in the user form.`
    },
    ENABLEPOSITIONSENIORITY: {
      LABEL: `Seniority by position`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the seniority by position field visible in the user form`
    },
    ENABLEEMPLOYEEID: {
      LABEL: `Employee ID`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the employee ID field visible in the user form`
    },
    ENABLESTATUS: {
      LABEL: `Status`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the status field visible in the user form`
    },
    ENABLESENIORITYDATE: {
      LABEL: `Seniority Date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the seniority date field visible in the user form`
    },
    ENABLEPRIORITYNUMBER: {
      LABEL: `Priority Number`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the priority number field visible in the user form`
    },
    ENABLESTARTDATE: {
      LABEL: `Start Date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the start date field visible in the user form`
    },
    ENABLETERMINATIONDATE: {
      LABEL: `Termination Date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the termination date field visible in the user form`
    },
    ENABLEPROJECTS: {
      LABEL: `Projects`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the projects field visible in the user form`
    },
    ENABLETEAMS: {
      LABEL: `Teams`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the teams field visible in the user form`
    },
    ENABLEDEPARTMENTS: {
      LABEL: `Departments`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the departments field visible in the user form`
    },
    ENABLESPECIFICRESTRICTIONS: {
      LABEL: `Specific restrictions`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the specific restrictions field visible in the user form`
    },
    ENABLEPAY: {
      LABEL: `Pay`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the pay field visible in the user form`
    },
    ENABLEEMERGENCYCONTACT: {
      LABEL: `Emergency contact`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting makes the emergency contact field visible in the user form`
    },
    USE_THIS_INPUT_TO_VALIDATE_REGEX: {
      LABEL: `Test the regular expression by entering a matching candidate password`,
      DESCRIPTION: ``
    },
    PROJECTCLIENTFIELD: {
      LABEL: `Enable project clients`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ENABLEPROJECTDEFAULTSHIFTTAGS: {
      LABEL: `Enable project default shift tags`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Default tags are loaded to a shift when a project that has default shift tags is assigned to it.`
    },
    PROJECTRESTRICTIONS: {
      LABEL: `Enable project restrictions`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enables fields in projects for locked, blocked and preferred users.`
    },
    PROJECTATTRIBUTES: {
      LABEL: `Enable project attributes`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enables attributes in projects to better determine employee eligibility.`
    },
    ENABLEASSOCIATEDPROJECTS: {
      LABEL: `Enable associated projects`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enables the calculation of associated projects when determining number of hours worked on a project.`
    },
    ENABLETEMPLATELISTINPROJECT: {
      LABEL: `Enable the template list in the project form`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enables a simplified view of the template list in the project form.`
    },
    REQUIRESHIFTVALIDATION: {
      LABEL: `Require schedule notification receipts`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enables schedule notification receipts, where a user has to confirm that they received the email or phone call.`
    },
    SHOWPOSITIONINEMAIL: {
      LABEL: `Show position in shift notifications`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Shows the position name in shift notifications, otherwise users would not know exactly what position they are working.`
    },
    SHOWPROJECTOWNERSINEMAIL: {
      LABEL: `Show project owners in shift notifications`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Shows the project owners in shift notifications, informs employees who is in charge of their projects and when they are working.`
    },
    CONFIRSHIFTEMAILBCC: {
      LABEL: `BCC-to email for schedule notifications`,
      PLACEHOLDER: ``,
      DESCRIPTION: `A blind carbon copy (BCC) of each notification will be sent to the complete list of emails provided. Separate emails using a semicolon (;).`
    },
    EMAILREPLYTO: {
      LABEL: `Reply-to email`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Defines a reply-to email for all emails sent by Merinio. Users replying to emails will send an email to the complete list of emails provided.`
    },
    REGIONALTAGS: {
      LABEL: `Enable regions`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows assignment of users to different regions and restricting users to work in specific regions.`
    },
    ENABLEOCCUPATIONS: {
      LABEL: `Enable occupations`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows assignment of a primary and secondary occupation to all users.`
    },
    ENABLEATTRIBUTES: {
      LABEL: `Enable attributes`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows management of eligible users using a matrix of user skills and required skills on positions.`
    },
    ENABLESHIFTSPECIFICATTRIBUTES: {
      LABEL: `Enable shift specific attributes`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows managers to set attributes that are specific to a single shift, regardless of position.`
    },
    PUNCHAUTHENTICATIONEMPLOYEEID: {
      LABEL: `Use employee id for punch terminal`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Require users to use their employee ID rather than employee number to log into the punch terminal.`
    },
    ENABLEUNPUNCHEDSHIFTSNOTIFICATION: {
      LABEL: `Enable unpunched shifts notifications`,
      PLACEHOLDER: ``,
      DESCRIPTION: `A notification by email will be sent every morning containing the list of unpunched shifts from the day before.`
    },
    INVERTNUMERICALKEYBOARD: {
      LABEL: `Invert punch keyboard`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Normally the punch keyboard ressembles a phone keyboard, inverting it will make it akin to a computer numpad.`
    },
    RECALCULATEPUNCHBREAKS: {
      LABEL: `Recalculate breaks`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Breaks will be automatically assigned to punch cards based on break rules, this will ignore any changes made within shifts.`
    },
    SORTPUNCHESBYEMPLOYEEFIELD: {
      LABEL: `Enable sorting of punches by name`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sort identical punches by user first or last name.`
    },
    PUNCHSORTFIELD: {
      LABEL: `Name to use`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PAYEXPORTCOMPANYID: {
      LABEL: `Company id for pay export`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This code will automatically be added to the punch export.`
    },
    DEFAULTREGULAREARNINGCODE: {
      LABEL: `Default earning code for regular time`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This code will automatically be added to the punch export for regular hours (not overtime).`
    },
    ENABLENOPUNCHINOUTNOTIFICATIONS: {
      LABEL: `Enable Push notifications for punch in and punch out`,
      PLACEHOLDER: ``,
      DESCRIPTION: `A push notification will be sent to employees within 5 minutes after the start or the end of their shift if they haven't punched in or punched out.`
    },
    ENABLEPOSITIONTRANSFER: {
      LABEL: `Enable position transfer`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows an employee to transfer positions during the same shift.`
    },
    ENABLEPROJECTTRANSFER: {
      LABEL: `Enable project transfer`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows an employee to transfer projects during the same shift.`
    },
    ENABLEWAGEPREMIUMS: {
      LABEL: `Enable wage premiums`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Wage premiums are used to modulate employee payroll for export to pay systems.`
    },
    PAYEXPORTTYPE: {
      LABEL: `Pay export type`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    PAYCODEEQUIVALENCES: {
      LABEL: `Pay code equivalences`,
      DESCRIPTION: ``,
      POSITION: `Position`,
      DEPARTMENT: `Department`,
      PROJECT: `Project`,
      EMPLOYEE: `Employee`,
      NETHRISEMPLOYEURD: {
        TITLE: `Nethris/EmployeurD equivalences`,
        REGULAREARNINGCODE: {
          LABEL: `Regular earning code`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        HOURLYRATE: {
          LABEL: `Hourly rate`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        DIVISION: {
          LABEL: `Division`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        SERVICE: {
          LABEL: `Service`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        DEPARTMENT: {
          LABEL: `Department`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        SUBDEPARTMENT: {
          LABEL: `Sub department`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        WORKS1: {
          LABEL: `Work code S1`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        },
        WORKS2: {
          LABEL: `Work code S2`,
          DESCRIPTION: ``,
          PLACEHOLDER: ``
        }
      },
      APOGEE: {
        TITLE: 'Apogée equivalences',
        FUNCCODE: {
          LABEL: `Func-Code`,
          PLACEHOLDER: `Entrez un code`,
          DESCRIPTION: ``
        },
        FUNCTLEVEL: {
          LABEL: `Funct-Level`,
          PLACEHOLDER: `Entrez un code`,
          DESCRIPTION: ``
        }
      }
    },
    DEFAULTPUNCHRULE: {
      LABEL: `Enable a default punch rule`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This punch rule will be used by default for positions and departments.`,
      PUNCHRULEID: {
        LABEL: `Choose a punch rule`,
        PLACEHOLDER: ``,
        DESCRIPTION: ``
      }
    },
    PREVENTEMPLOYEEEARLYOUTREQUESTS: {
      LABEL: `Prevent employees from creating early out requests`,
      PLACEHOLDER: ``,
      DESCRIPTION: `It will only be possible to create early out requests from the manager portal.`
    },
    PREVENTEMPLOYEELATEREQUESTS: {
      LABEL: `Prevent employees from creating late requests`,
      PLACEHOLDER: ``,
      DESCRIPTION: `It will only be possible to create late requests from the manager portal.`
    },
    PREVENTEMPLOYEEABSENCEREQUESTS: {
      LABEL: `Prevent employees from creating absence requests`,
      PLACEHOLDER: ``,
      DESCRIPTION: `It will only be possible to create absence requests from the manager portal.`
    },
    CREATEATTENDANCEWITHOUTSHIFT: {
      LABEL: `Allow creating attendance without a shift`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to create an attendance request even if they are not assigned to the schedule. They will have the choice of creating a request for up to one day in the future.`
    },
    CREATEATTENDANCEONLYONCONFIRMEDSHIFT: {
      LABEL: `Prevent creating attendance for unconfirmed shifts`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Prevent users from creating attendance requests for a shift that has not yet been confirmed. If they are allowed to create a request without a shift, they will still be able to create a request for the day.`
    },
    ATTENDANCEOVERPHONENOSHIFTMATCHING: {
      LABEL: `Prevent system from trying to match attendance request with shifts`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    NUMBEROFDAYSINADVANCEOFATTENDANCEREQUEST: {
      LABEL: `Number of days ahead of a time a user can create an attendance request`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Limits how many days ahead a user can create an attendance request for. Requests outside of this range will have to go through the time off module. (Maximum of 9 days)`
    },
    DONTOFFERATTENDANCEQUICKCREATE: {
      LABEL: `Prevent quick absence during phone notifications`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Prevents the message offering to quickly create an attendance for a shift from playing when sending a shift notification over the phone.`
    },
    DONTSHOWPHONENUMBERATTENDANCE: {
      LABEL: `Hide incoming phone number on attendance requests`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Hides the phone number used during the creation of an attendance request when the user viewing them does not have permissions to view user contact info.`
    },
    REDIRECTTOPHONEONLEAVE: {
      LABEL: `Manager phone number redirect on attendance request`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Activates a manager number to redirect to when a user has finished creating an attendance request. The manager will be able to see the incoming number of the user.`
    },
    REDIRECTTOPHONEONLEAVEPHONENUMBER: {
      LABEL: `Manager phone number`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Phone number to use during the redirect.`
    },
    REDIRECTTOPHONEONLEAVEPHONENUMBEREXTENSION: {
      LABEL: `Manager extension`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    DEFAULTLEAVESTATUS: {
      LABEL: `Default attendance request status`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Defines the request status to be used when an employee creates an attendance request.`
    },
    ATTENDANCEDESCRIPTIONENABLED: {
      LABEL: `Enable custom description in attendance creation form`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This text will show up in the attendance creation form in a blue alert.`
    },
    ATTENDANCEDESCRIPTIONEN: {
      LABEL: `Custom description for attendance form in english`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ATTENDANCEDESCRIPTIONFR: {
      LABEL: `Custom description for attendance form in french`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ABSENCEBANKENABLED: {
      LABEL: `Enable absence bank`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enables the use of an absence bank that will warn users when they are about to exceed the number of allowed absences per period.`
    },
    ABSENCEBANKMAXREQUESTS: {
      LABEL: `Number of permitted absences per period`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Once this number is reached, a user will be warned when creating an absence request.`
    },
    ABSENCEBANKPERIOD: {
      LABEL: `Duration of period`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Rolling period in days to use when calculating how may absence requests have been created.`
    },
    HOURSPERPERIODRRW: {
      LABEL: `Enable right to refuse to work`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enables a calculation to determine whether a user was allowed to refuse to work a shift. Depending on jurisdiction, an employee might be able to refuse to work over a certain number of hours per period.`
    },
    MAXHOURSPERPERIODRRW: {
      LABEL: `Number of hours per period`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    MAXHOURSPERIODRRW: {
      LABEL: `Duration of period`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    MANDATORYCREATEREQUESTCOMMENT: {
      LABEL: `Force comment on request submission`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This setting applies to attendance, time off and availability and will force a user to enter a comment before submitting.`
    },
    ACTIVATETEMPORARYAVAILABILITIES: {
      LABEL: `Activate temporary availabilities`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows employees to create an availability with an end date.`
    },
    APPROVEAVAILABILITIESAUTOMATICALLY: {
      LABEL: `Automatically approve availabilities`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Availaibilities created by an employee will automatically be approved without requiring manager intervention.`
    },
    ENABLEPREFERREDRANGES: {
      LABEL: `Enable preferred ranges`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows employees to create ranges of time they prefer to work.`
    },
    ENABLEATTRIBUTESEXPIRATION: {
      LABEL: `Enable attributes expiration`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows to add an expiration date to an attribute, and set up reminders to send to the employees.`
    },
    ENABLEELIGIBILITYFIX: {
      LABEL: `Enable eligibility problems quick fix `,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows to address all eligibility issues directly when creating a new shift.`
    },
    ENABLEINAPPCHAT: {
      LABEL: `Enable in-app chat`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows users to communicate between themselves directly in the application.`
    },
    ENABLENEWCHAT: {
      LABEL: `Enable new chat`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Use the new chat`
    },
    ENABLEAUTOMATICOVERTIME: {
      LABEL: `Enable overtime calculation`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allow administrators to set a daily and weekly threshold for overtime in punch cards.`
    },
    AVAILABILITYDESCRIPTIONENABLED: {
      LABEL: `Enable custom description in availability creation form`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This text will show up in the availability creation form in a blue alert.`
    },
    AVAILABILITYDESCRIPTIONEN: {
      LABEL: `Custom description for availability form in english`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    AVAILABILITYDESCRIPTIONFR: {
      LABEL: `Custom description for availability form in french`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ENABLEAVAILABILITYSUBMISSIONCUTOFF: {
      LABEL: `Enable cutoff date for availabilities`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Set a date and time for an upcoming week that will prevent employees with this hiring data type from submitting their availabilities after the cutoff. We recommend explaning how this works in the custom description field for availabilities.`
    },
    AVAILABILITYSUBMISSIONCUTOFFDAYOFWEEK: {
      LABEL: `Day of week`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Day to use for the cutoff`
    },
    AVAILABILITYSUBMISSIONCUTOFFTIME: {
      LABEL: `Time of day`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Time to use for the cutoff in the users's timezone.`
    },
    AVAILABILITYSUBMISSIONCUTTOFFNUMBEROFWEEKSAHEAD: {
      LABEL: `Number of weeks ahead`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Enter 1 for the next week and higher numbers for other weeks, entering zero (0) will do nothing.`
    },
    AVAILABILITYSUBMISSIONCUTTOFFREMINDER: {
      LABEL: `Enable reminder for submission cutoff of availabilities`,
      DESCRIPTION: `A reminder will be sent by push notification 4 hours before the cutoff time to all employees who have activated their notifications.`
    },
    TIMEOFFDESCRIPTIONENABLED: {
      LABEL: `Enable custom description in time off creation form`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This text will show up in the time off creation form in a blue alert.`
    },
    TIMEOFFDESCRIPTIONEN: {
      LABEL: `Custom description for time off form in english`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    TIMEOFFDESCRIPTIONFR: {
      LABEL: `Custom description for time off form in french`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    OVERLAPPINGTIMEOFFWARNING: {
      LABEL: `Display warning only for overlapping time offs`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Will only display a warning when creating a new time off that is overlapping an existing one. Submitting action of the form will be allowed.`
    },
    SHOWVACATIONBANKEDMINUTESFIELD: {
      LABEL: `Enable vacation bank`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows managers to determine how much vacation a user has accumulated. Used only in the vacation distribution module.`
    },
    VALIDATEINFORMATIONSENDEMAILRESOURCE: {
      LABEL: `Email to use for requested changes`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Separate emails using a semicolon (;), messages will also appear in the user management module.`
    },
    EMAILFORFEEDBACKNOTIFICATIONS: {
      LABEL: `Email to send user feedback to`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If a user clicks on the give feedback button at the bottom of the page and asks to send feedback to the employer, it will be sent to this email.`
    },
    EMAILFORATTRIBUTEEXPIRATIONREMINDERS: {
      LABEL: `Email to send attributes expiration reminders to`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If the option is checked on the reminder, it will send the reminder not only to the employee but also to this email. Separate emails using a semicolon (;)`
    },
    EMAILFORUNPUNCHEDSHIFTSNOTIFICATIONS: {
      LABEL: `Email to send notifications to.`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ACTIVATEEXPIREDHIRINGDATANOTIFICATIONEMAIL: {
      LABEL: `Enable hiring data expiration notifications`,
      PLACEHOLDER: ``,
      DESCRIPTION: `A notification will be sent every night containing the users who have hiring data about to expire.`
    },

    EXPIREDHIRINGDATANOTIFICATIONEMAIL: {
      LABEL: `Emails to use for hiring data expiration notifications`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Separate emails using a semicolon (;).`
    },
    EXPIREDHIRINGDATAEMAILDAYSTOCHECK: {
      LABEL: `Number of days ahead of time to check for expiration`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Value is 7 days by default.`
    },
    FALLBACKHIRINGDATA: {
      LABEL: `Fallback hiring data`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If a type of hiring data has a fallback value, it will be replaced by the fallback the night before it expires.`
    },
    TRANSFEREVENTSINS3: {
      LABEL: `Enable transfer of shifts to S3`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Allows API access to an entire year or month. Shifts are transferred regularly.`
    },
    WEBAPPAUTHTENTATIVE: {
      LABEL: `Maximum number of tries for password`,
      PLACEHOLDER: ``,
      DESCRIPTION: `A user will be prevented from logging in if they exceed the number of allowed tries and will be forced to reset their password. (Use 0 for unlimited tries)`
    },
    PHONEPINENABLE: {
      LABEL: `Enable phone PIN`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Users that call the system will have to use a password to authenticate themselves.`
    },
    PHONETENTATIVEENDMESSAGEFR: {
      LABEL: `Phone pin maximum number of tries exceeded message in french`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Adds a custom message in french to the phone system when a user has exceeded their number of PIN tries. `
    },
    PHONETENTATIVEENDMESSAGEEN: {
      LABEL: `Phone pin maximum number of tries exceeded message in english`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Adds a custom message in english to the phone system when a user has exceeded their number of PIN tries. `
    },
    PHONEAUTHTENTATIVE: {
      LABEL: `Maximum number of tries for phone PIN`,
      PLACEHOLDER: ``,
      DESCRIPTION: `A user will be prevented from logging in if they exceed the number of allowed tries and will be forced to contact their manager to reset their PIN. (Use 0 for unlimited tries)`
    },
    CUSTOMPASSWORDVALIDATION: {
      LABEL: `Enable custom password validation`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Merinio requires a 8 character password with a maximum length of 64 by default. If this option is activated, the regex expression below will be used for password validation`
    },
    CUSTOMPASSWORDVALIDATIONREGEX: {
      LABEL: `Custom password validation Regex`,
      PLACEHOLDER: ``,
      DESCRIPTION: `For example, entering "[a-zA-Z0-9] {8,20}" in this field will make only alphanumerical passwords between 8 and 20 characters valid.`
    },
    CUSTOMPASSWORDVALIDATIONMSG: {
      LABEL: `Custom password validation message`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enter a brief message to explain custom password requirements to users.`
    },
    COMPANYDEFAULTLANGUAGE: {
      LABEL: `Default language`,
      DESCRIPTION: `Determines which language to use when creating new employees and which language the phone system will use by default.`
    },
    ENABLEPUNCHQUESTIONNAIRE: {
      LABEL: `Enable punch questionnaire`,
      DESCRIPTION: `Employees will have to fill out a questionnaire before punching in using the punch terminal`
    },
    ENABLEPUNCHCOMMENT: {
      LABEL: `Enable comments when punching in or out late or early`,
      DESCRIPTION: `Employees who punch in or out late or early will have the possibility to write a comment to their manager.`
    },
    PUNCHQUESTIONNAIREEMAILTOONERROR: {
      LABEL: `Email to send warnings to`,
      PLACEHOLDER: `Enter emails`,
      DESCRIPTION: `Will be used to send emails when a user triggers a warning or adds an explanation, use semicolons ";" to separate entries.`
    },
    PUNCHQUESTIONNAIRECUSTOMERROR: {
      LABEL: `Error message to show employee`,
      PLACEHOLDER: `Enter a message`,
      DESCRIPTION: `This message will be shown to an employee that has answered yes to at least one of the questions. This should contain instructions.`
    },
    PUNCHQUESTIONNAIRECUSTOMEXPLANATION: {
      LABEL: `Explanation to show employee`,
      PLACEHOLDER: `Enter a message`,
      DESCRIPTION: `This message should explain why the user is filling out a questionnaire.`
    },
    PUNCHQUESTIONNAIRETIMEBETWEENFILLS: {
      LABEL: `Time between questionnaires.`,
      PLACEHOLDER: `Enter a number of hours`,
      DESCRIPTION: `Defines the interval at which users will be required to fill the punch questionnaire.`
    },
    PUNCHQUESTIONNAIREQUESTIONS: {
      LABEL: `Punch questionnaire questions`,
      DESCRIPTION: `Questions to ask when a user punches in when questionnaire is active.`,
      TEXT: {
        LABEL: `Question to ask`,
        PLACEHOLDER: `Enter a question`,
        DESCRIPTION: `This must be a yes or no question, as the employee will only have two options when answering.`
      },
      PREVENTSUSERFROMPUNCHING: {
        LABEL: `Prevent user from punching`,
        DESCRIPTION: `If the user answers yes to this question, they will be prevented from punching.`
      },
      ADD_QUESTION: `Add question`
    },
    ENABLEDAILYQUESTIONNAIRE: {
      LABEL: `Enable daily questionnaire`,
      DESCRIPTION: `Employees will have to fill out a questionnaire after logging in.`
    },
    SENDDAILYQUESTIONNAIREREMINDERS: {
      LABEL: `Send reminders`,
      DESCRIPTION: `A reminder will be sent once per day to all employees that have not yet filled out the questionnaire.`
    },
    ENABLEDAILYQUESTIONNAIREBYPHONE: {
      LABEL: `Allows responses by phone`,
      DESCRIPTION: `Users will be able to fill the daily questionnaire over the phone.`
    },
    DAILYQUESTIONNAIREEMAILTOONERROR: {
      LABEL: `Email to send warnings to`,
      PLACEHOLDER: `Enter emails`,
      DESCRIPTION: `Will be used to send emails when a user triggers a warning or adds an explanation, use semicolons ";" to separate entries.`
    },
    DAILYQUESTIONNAIREHIRINGDATA: {
      LABEL: `Hiring data types`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Require only certain hiring data types to fill out the questionnaire. Leave blank to require all types.`
    },
    DAILYQUESTIONNAIRECUSTOMERROR: {
      LABEL: `Error message to show employee`,
      PLACEHOLDER: `Enter a message`,
      DESCRIPTION: `This message will be shown to an employee that has answered yes to at least one of the questions. This should contain instructions.`
    },
    DAILYQUESTIONNAIRECUSTOMEXPLANATION: {
      LABEL: `Explanation to show employee`,
      PLACEHOLDER: `Enter a message`,
      DESCRIPTION: `This message should explain why the user is filling out a questionnaire.`
    },
    DAILYQUESTIONNAIRETIMEBETWEENFILLS: {
      LABEL: `Time between questionnaires.`,
      PLACEHOLDER: `Enter a number of hours`,
      DESCRIPTION: `Defines the interval at which users will be required to fill the daily questionnaire.`
    },
    DAILYQUESTIONNAIREQUESTIONS: {
      LABEL: `Daily questionnaire questions`,
      DESCRIPTION: `Questions to ask when a user logs in when questionnaire is active.`,
      TEXT: {
        LABEL: `Question to ask`,
        PLACEHOLDER: `Enter a question`,
        DESCRIPTION: `This must be a yes or no question, as the employee will only have two options when answering.`
      },
      TRIGGERSERRORMESSAGE: {
        LABEL: `Triggers error message`,
        DESCRIPTION: `If the user answers yes to this question, they will be shown the error message.`
      },
      ADD_QUESTION: `Add question`
    },
    ENABLEATTENDANCEREPORT: { LABEL: `Enable the attendance report`, DESCRIPTION: `` },
    ENABLEATTRIBUTESREPORT: { LABEL: `Enable the attributes report`, DESCRIPTION: `` },
    ENABLEEXPIRINGATTRIBUTESREPORT: { LABEL: `Enable the expiring attributes report`, DESCRIPTION: `` },
    ENABLEAVAILABILITYREPORT: { LABEL: `Enable the availability report`, DESCRIPTION: `` },
    ENABLECONTACTLISTACCEPTEDREFUSEDREPORT: { LABEL: `Enable the contact lists acceptation/refusal report`, DESCRIPTION: `` },
    ENABLEDAILYSUMMARYREPORT: { LABEL: `Enable the daily summary report`, DESCRIPTION: `` },
    ENABLEPAYREPORT: { LABEL: `Enable the pay report`, DESCRIPTION: `` },
    ENABLETIMEOFFANDATTENDANCEPAYREPORT: {
      LABEL: `Enable the pay report for time offs and attendances`,
      DESCRIPTION: ``
    },
    ENABLEPROJECTOWNERWORKLOADREPORT: { LABEL: `Enable the project owner workload report`, DESCRIPTION: `` },
    ENABLEPROJECTSCHEDULINGREPORT: { LABEL: `Enable the project scheduling report`, DESCRIPTION: `` },
    ENABLEPROJECTUSERSTATUSREPORT: { LABEL: `Enable the project user status report`, DESCRIPTION: `` },
    ENABLEQUESTIONNAIRERESPONSEREPORT: { LABEL: `Enable the questionnaire responses report`, DESCRIPTION: `` },
    ENABLESCHEDULEANALYSISREPORT: { LABEL: `Enable the schedule analysis report`, DESCRIPTION: `` },
    ENABLESCHEDULECAPACITYDEBUGREPORT: { LABEL: `Enable the schedule capacity debugging report`, DESCRIPTION: `` },
    ENABLESCHEDULEEXPORT: { LABEL: `Enable the schedule export`, DESCRIPTION: `` },
    ENABLETIMEOFFREPORT: { LABEL: `Enable the time off report`, DESCRIPTION: `` },
    ENABLEUNSCHEDULEDUSERSREPORT: { LABEL: `Enable the unscheduled users report`, DESCRIPTION: `` },
    ENABLEUSERCONTACTREPORT: { LABEL: `Enable the user contact report`, DESCRIPTION: `` },
    ENABLEBILLINGDETAILS: {
      LABEL: `Enable billing details`,
      DESCRIPTION: `Adds a section when editing shifts that can be used to add billing details.`
    },
    HIDEPROJECTCODE: {
      LABEL: `Hide projects codes`,
      DESCRIPTION: `Won't display the project code for each shift.`
    },
    HIDEORGANIZEBYPROJECTSCHEDULE: {
      LABEL: `Hide view by project in schedule`,
      DESCRIPTION: `Won't display the option to organise the schedule by project.`
    },
    HIDEORGANIZEBYPOSITIONSCHEDULE: {
      LABEL: `Hide view by position in schedule`,
      DESCRIPTION: `Won't display the option to organise the schedule by position.`
    },
    HIDEORGANIZEBYTEAMSCHEDULE: {
      LABEL: `Hide view by team in schedule`,
      DESCRIPTION: `Won't display the option to organise the schedule by team.`
    },
    HIDEORGANIZEBYUSERSCHEDULE: {
      LABEL: `Hide view by user in schedule`,
      DESCRIPTION: `Won't display the option to organise the schedule by user.`
    }
  },
  integrationStatus: {
    LOADING_STATUS: `Loading status`,
    USERS: `Users`,
    POSITIONS: `Positions`,
    PROJECTS: `Projects`,
    SCHEDULE: `Schedule`,
    TAGS: `Tags`,
    TIMEOFF: `Time off`,
    INTEGRATION_STATUS: `<0>{{type}}</0> synced <1>{{lastTime}}</1>`,
    NO_INTEGRATION_STATUS: `<0>{{type}}</0> has not run yet.`
  },
  clientOptions: {
    SALE_IN_PROGRESS: 'Sale in progress',
    TRIAL: 'Trial',
    ONBOARDING: 'Onboarding',
    DEMO: 'Demo',
    TEMPLATE: 'Template',
    ACTIVE: 'Active',
    SLIPPING_WAY: 'Slipping away',
    TERMINATED: 'Terminated'
  }
}
